"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDatedFilename = function (baseFileName, fileExtensionNoDot) {
    if (!baseFileName || typeof baseFileName !== "string") {
        baseFileName = "unnamed";
    }
    if (!fileExtensionNoDot || typeof fileExtensionNoDot !== "string") {
        fileExtensionNoDot = "file";
    }
    var dateString = new Date().toLocaleDateString().replace(/[^\dA-Za-z]/, "-");
    return baseFileName + "-" + dateString + "." + fileExtensionNoDot;
};
exports.downloadCSV = function (textCsvData, fileName) {
    var dataBlob = new Blob([textCsvData], { type: "text/csv" });
    var objectURL = window.URL.createObjectURL(dataBlob);
    var link = document.createElement("a");
    link.setAttribute("href", objectURL);
    link.setAttribute("download", fileName);
    document.body && document.body.appendChild(link);
    link.click();
};
exports.downloadCSVFromBase64 = function (textCsvData, fileName) {
    var decodedData = atob(textCsvData);
    exports.downloadCSV(decodedData, fileName);
};
